import { Input } from 'antd'

export const InputTitle = (props) => {
  return (
    <Input
      maxLength={45}
      {...props}
    />
  )
}

export const InputPlain = (props) => {
  return <Input style={{ maxWidth: '450px' }} {...props} />
}
